import PdfTcle from "./PdfTcle";

function PdfTcleWrapper({ showPreviousPage, tcleData }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfTcle tcleData={tcleData} showPreviousPage={showPreviousP} />
    </div>
  );
}

export default PdfTcleWrapper;
